import accessToken from "./accessToken";
import jwtDecode from "jwt-decode";

export const APP_ROLES = ["Administrator", "PowerUser", "StandardUser"];

// Federated (SSO) users also belong to Cognito's auto-created "<poolId>_<provider>" group,
// which can appear before the app role in cognito:groups.
export const resolveUserRole = (groups) => {
  if (!Array.isArray(groups) || groups.length === 0) return "";
  return groups.find((group) => APP_ROLES.includes(group)) || groups[0];
};

const getUserRole = () => {
  const token = accessToken();
  if (token) {
    const decoded = jwtDecode(token);
    const userName = decoded["email"];
    const userRole = resolveUserRole(decoded["cognito:groups"]);
    return userRole;
  }
  return "NONE";
}

export default getUserRole;

// Function to retrieve the username (email) from the access token
export const getUsername = () => {
  const token = accessToken();
  if (token) {
    const decoded = jwtDecode(token);
    const userName = decoded["email"];
    return userName || "";
  }
  return "";
};
